export const LIMIT_CLANS = 3;

export const LIMIT_ORDERS = 10;
export const LIMIT_NFTS = 20;

export const LIMIT_NOTICES = 10;

export const DEFAULT_LIMIT = 10;
